module.exports = __webpack_public_path__ + "img/tc1.31805970.png";